import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from "../components/layout";
export const _frontmatter = {
  "title": "Installation",
  "menuPosition": 3
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Layout mdxType="Layout">
      <SEO title="Installation" mdxType="SEO" />
      <h1>{`Installation`}</h1>
      <p>{`Install archie with:`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`go get github.com/briggysmalls/archie/cli/archie
`}</code></pre>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      